/**
 * Format milliseconds as m:ss (e.g. 125000 → "2:05").
 * Used for playback timers and duration display.
 */
export function formatMs(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) {
    return '0:00'
  }
  const totalSeconds = Math.floor(ms / 1000)
  const m = Math.floor(totalSeconds / 60)
  const s = totalSeconds % 60
  return `${m}:${String(s).padStart(2, '0')}`
}
